<template>
  <div>
    <div
      id="exampleModalLive"
      :class="['modal fade', { show: showModal }]"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLiveLabel"
      :style="display"
    >
      <div
        class="modal-dialog"
        role="document"
        :style="{
          width: $store.state.style.modal.width + $store.state.style.modal.prefixWidth,
          'max-width': 100 + '%',
        }"
      >
        <div
          class="modal-content"
          :style="{
            height: $store.state.style.modal.height + $store.state.style.modal.prefixHeight,
          }"
        >
          <slot></slot>
        </div>
      </div>
    </div>
    <div :class="['modal-backdrop fade', { show: showModal }]" :style="display"></div>
  </div>
</template>
<script>
export default {
  props: ['showhide'],
  data() {
    return {
      showModal: false,
      display: 'display: none',
    };
  },
  watch: {
    showhide() {
      var vm = this;
      if (this.showhide === true) {
        this.display = 'display: block;';
        setTimeout(() => {
          vm.showModal = true;
        }, 250);
      } else {
        // this.display = 'display: none;'
        // vm.showModal = false
        this.closeModal();
      }
    },
  },
  methods: {
    // close the modal smoothly
    closeModal() {
      var vm = this;
      this.showModal = false;
      setTimeout(() => {
        vm.display = 'display: none;';
      }, 250);
    },
  },
};
</script>
<style lang="scss" scoped>
/*
   TOC:
  =======

  1. Primary Styles

  2. Custom Utility Classes

  3. Custom Styles

===================================================== */

/* --------------------------------- */
/* 1. Primary Styles
 ----------------------------------- */

/* --------------------------------- */
/* 2. Custom Utility Classes
 ----------------------------------- */

/* --------------------------------- */
/* 15. Custom Styles
----------------------------------- */
/*customizing boostrap*/
#exampleModalLive {
  background-color: rgba(64, 157, 164, 0.6);
  font-family: 'comfortaaregular';
}
.modal-content {
  border-radius: 10px;
  border: 0;
  // top: 3vh;
}
.modal-backdrop.fade.show {
  background-color: rgba(0, 0, 0, 0.2);
}
.modal-dialog {
  margin: 0 auto;
  height: calc(100vh);
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
